/**
 * Environment configuration utility
 * Handles both Vite (import.meta.env) and Create React App (process.env) environments
 */

const getEnvVar = (key) => {
  // Try Vite first
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env[key];
  }
  
  // Fallback to process.env (Create React App)
  if (typeof process !== 'undefined' && process.env) {
    return process.env[key];
  }
  
  return undefined;
};

// Determine API URL based on environment
const isProduction = process.env.NODE_ENV === 'production';
const productionUrl = 'https://api.codebattles.in';
const apiUrl = isProduction 
  ? productionUrl 
  : (getEnvVar('VITE_API_URL') || getEnvVar('REACT_APP_API_URL') || 'http://localhost:5000');

export const config = {
  apiUrl: apiUrl,
  api: {
    baseURL: apiUrl,
    socketURL: apiUrl
  },
  emailJs: {
    serviceId: getEnvVar('VITE_EMAILJS_SERVICE_ID') || getEnvVar('REACT_APP_EMAILJS_SERVICE_ID'),
    templateId: getEnvVar('VITE_EMAILJS_TEMPLATE_ID') || getEnvVar('REACT_APP_EMAILJS_TEMPLATE_ID'),
    publicKey: getEnvVar('VITE_EMAILJS_PUBLIC_KEY') || getEnvVar('REACT_APP_EMAILJS_PUBLIC_KEY')
  }
};

export default config;
